import dayjs from "dayjs"
import get from "lodash.get"
import {
	getClientContact,
	getClientIdentity,
	serializeClientAddresses
} from "@/utils/"
import { getFacts } from "./utils/"

export default (ctx, payload) => {
	const header = schema(ctx, payload).map(item => item.label)
	const body = payload.map(data => schema(ctx).map(y => [y.data(data)]))
	const workSheetData = [header, ...body]
	const workSheetColumns = schema(ctx).map(item => {
		return { wpx: 150 }
	})
	return { workSheetData, workSheetColumns }
}

const schema = ctx => [
	{ label: "Name", data: item => get(item, "name") },
	{ label: "English First Name", data: item => get(item, "englishFirstName") },
	{ label: "English Last Name", data: item => get(item, "englishLastName") },
	{ label: "Chinese First Name", data: item => get(item, "chineseFirstName") },
	{ label: "Chinese Last Name", data: item => get(item, "chineseLastName") },
	{ label: "Gender", data: item => get(item, "gender") },
	{ label: "Salutation", data: item => get(item, "salutation") },
	{
		label: "Date of Birth",
		data: item =>
			item.dateOfBirth
				? dayjs(item.dateOfBirth).format(ctx.settings.dateFormat)
				: null
	},
	{ label: "Marital Status", data: item => get(item, "maritalStatus") },
	{ label: "Occupation", data: item => get(item, "occupation") },
	{
		label: "Country of Residency",
		data: item => get(item, "countryOfResidency")
	},
	{ label: "Accepts Marketing", data: item => get(item, "acceptsMarketing") },
	{
		label: "Preferred Communication",
		data: item => get(item, "preferredCommunicationChannel")
	},
	{ label: "Preferred Language", data: item => get(item, "preferredLanguage") },
	{ label: "HKID", data: item => getClientIdentity("hkid", item.identities) },
	{
		label: "Passport",
		data: item => getClientIdentity("passport", item.identities)
	},
	{ label: "Email", data: item => getClientContact("email", item.contacts) },
	{
		label: "Phone",
		data: item => getClientContact("telephoneNumber", item.contacts)
	},
	{ label: "Fax", data: item => getClientContact("fax", item.contacts) },
	{
		label: "WhatsApp",
		data: item => getClientContact("whatsapp", item.contacts)
	},
	{ label: "WeChat", data: item => getClientContact("wechat", item.contacts) },
	{ label: "Web", data: item => getClientContact("web", item.contacts) },
	{
		label: "Addresses",
		data: item => serializeClientAddresses(item.addresses)
	},
	{ label: "Facts", data: item => getFacts(item.facts) },
	{
		label: "Created",
		data: item =>
			item.createdAt
				? dayjs(item.createdAt).format(ctx.settings.dateTimeFormat)
				: null
	}
]
